import styled from "styled-components";
// import Slider from "react-slick";

// export const ImgSliderStyle = styled(Slider)``;

export const ImgStyle = styled.div`
  height: 62vh;
  width: 100%;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
`;
